import { useActiveTeam } from "~/hooks/useTeamAccess";
import { isHiddenForPitch } from "~/lib/pitch";
import { Navigate, useLocation } from "~/lib/team-router";

export default function PitchRouteGuard() {
  const activeTeam = useActiveTeam();
  const { pathname } = useLocation();

  if (activeTeam?.is_pitch && isHiddenForPitch(pathname)) {
    return <Navigate to="/ai-visibility/home" replace />;
  }
  return null;
}
